import { Link } from "react-router-dom";
import { Disc3, ShieldCheck } from "lucide-react";

const Section = ({ title, children }) => (
  <section className="mt-8">
    <h2 className="font-display text-xl font-bold text-[#FFD60A]">{title}</h2>
    <div className="mt-2 text-sm leading-relaxed text-zinc-300 space-y-3">{children}</div>
  </section>
);

const Legal = () => {
  const year = new Date().getFullYear();
  return (
    <div className="mx-auto max-w-3xl px-4 sm:px-6 py-12 pb-24" data-testid="legal-page">
      <Link to="/" className="inline-flex items-center gap-2 mb-6">
        <Disc3 className="h-6 w-6 text-[#FFD60A]" />
        <span className="font-brand text-xl text-[#FFD60A]">NEXTtt<sup className="text-[0.5em] align-super ml-0.5">™</sup></span>
      </Link>

      <h1 className="font-display text-3xl sm:text-4xl font-black tracking-tighter text-white flex items-center gap-3">
        <ShieldCheck className="h-8 w-8 text-[#FFD60A]" /> Legal, Copyright &amp; Trademark
      </h1>
      <p className="text-zinc-400 mt-3">Effective {year}. These terms protect the NEXTtt platform, its brand, and every artist who posts here.</p>

      <Section title="Copyright">
        <p>© {year} NEXTtt. All rights reserved. The NEXTtt platform — including its name, logo, wordmark, design, layout, graphics, and software — is the exclusive property of its owner and is protected by copyright law. No part of this platform may be copied, reproduced, cloned, or redistributed without prior written permission.</p>
      </Section>

      <Section title="Trademark">
        <p><span className="font-brand text-[#FFD60A]">NEXTtt<sup className="text-[0.5em] align-super ml-0.5">™</sup></span> and the NEXTtt logo/wordmark are trademarks of the platform owner (stage name “HOODI-X”). Unauthorized use of the NEXTtt name, logo, or any confusingly similar mark is strictly prohibited and may result in legal action.</p>
      </Section>

      <Section title="Platform Ownership">
        <p>NEXTtt is owned and operated by its founder. All platform code, branding, and design belong solely to the owner. No user, artist, or third party may claim ownership of, take over, or misrepresent affiliation with the NEXTtt platform.</p>
      </Section>

      <Section title="Artist Content Rights">
        <p>Music videos uploaded to NEXTtt remain the property of the posting artist. By uploading, artists confirm they own or control all rights to their content and grant NEXTtt a non-exclusive license to host, display, and enable sharing of that content on and from the platform.</p>
        <p>Artists are solely responsible for ensuring their uploads do not infringe the rights of any third party.</p>
      </Section>

      <Section title="Acceptable Use">
        <p>NEXTtt is an 18+ platform. Users may not scrape, copy, resell, or redistribute platform content; attempt to gain unauthorized access; impersonate the owner or another artist; or use the platform for unlawful purposes.</p>
      </Section>

      <Section title="Copyright Infringement (DMCA)">
        <p>If you believe your copyrighted work has been used on NEXTtt without authorization, submit a notice to the platform administrator including: your contact details, identification of the copyrighted work, the location of the infringing material, and a good-faith statement. Verified claims will be removed promptly.</p>
      </Section>

      <p className="mt-10 text-xs text-zinc-500">© {year} NEXTtt<sup className="align-super">™</sup>. All rights reserved.</p>
    </div>
  );
};

export default Legal;
